export default __webpack_public_path__ + "static/media/masteratarms.474a0ba8.png";